// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f225696e","239":"bd83c7d1","455":"6eac5b07"}[chunkId] + ".chunk.js";
};